import { Component, input, output } from '@angular/core';
import { BaseCardComponent } from '../base-card/base-card.component';
import { ActionCardIconComponent } from './action-card-icon.component';
import { LinkComponent } from '../../link/link.component';

@Component({
  imports: [BaseCardComponent, ActionCardIconComponent, LinkComponent],
  selector: 'ui-action-card',
  template: `
    <ui-base-card [class]="'justify-between'" [reverse]="true">
      <ui-action-card-icon icon class="{{ iconClass() }}" [icon]="icon()" />
      <ng-container content>
        <div class="flex gap-x-8 px-1">
          @for (item of items(); track $index) {
            <div [class]="'flex flex-col ' + item?.class">
              <span class="text-sm text-gray-400 font-medium">
                {{ item.label }}
              </span>
              <span class="text-2xl">
                {{ item?.count ?? '--' }}
              </span>
            </div>
          }
        </div>

        <ui-link (linkClick)="handleLinkClick()">
          <span class="text-base">
            {{ label() }}
          </span>
        </ui-link>
      </ng-container>
    </ui-base-card>
  `,
})
export class ActionCardComponent {
  items = input<{ label?: string; count: number | null; class?: string }[]>([
    { count: 0 },
  ]);
  label = input<string>();
  isLink = input<boolean>(false);
  icon = input<string>();
  iconClass = input<string>();

  linkClick = output<void>();

  handleLinkClick() {
    this.linkClick.emit();
  }
}
